import React, { useRef } from 'react';
import { useDisclosure } from '../../../../hooks';
import useOnClickOutside from '../../../../hooks/useOnClickOutside';
import { classNames } from '../../../../utils';
import { nullFn } from '../../utils';

type CalendarHeaderYearSelectorProps = {
  currentYear?: number;
  yearsList?: number[];
  handleOnClick?: (year: number) => void;
};

export default function CalendarHeaderYearSelector({
  yearsList = [],
  currentYear = new Date().getFullYear(),
  handleOnClick = nullFn,
}: CalendarHeaderYearSelectorProps): JSX.Element {
  const ref = useRef(null);
  const {
    isOpen: showList,
    close: closeYearList,
    toggle: toggleYearList,
  } = useDisclosure(false);

  const handleItemClicked = (year: number) => {
    closeYearList();
    handleOnClick(year);
  };

  useOnClickOutside(ref, closeYearList);

  return (
    <div className='relative' ref={ref}>
      <button
        type='button'
        className='capitalize m-0 p-0 text-gray-dark border-b border-green'
        onClick={toggleYearList}
      >
        {currentYear}
      </button>
      {showList && (
        <div className='absolute top-full w-64 bg-white border border-gray-lightest shadow-lg z-20 rounded-lg py-2 px-2 max-h-48 overflow-y-auto mt-2 transform -translate-x-1/2 left-1/2'>
          <div className='flex flex-row flex-wrap'>
            {yearsList.map((item, idx) => (
              <button
                type='button'
                key={`YEARS__${idx}`}
                onClick={() => handleItemClicked(item)}
                className={classNames(
                  'w-1/3 py-2 flex justify-center rounded-lg hover:bg-green-lightest cursor-pointer',
                  currentYear === item
                    ? 'text-green-dark bg-green-light'
                    : 'text-gray-dark',
                )}
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
